import { render } from "./MeasurementsForm.vue?vue&type=template&id=79e348e1&scoped=true"
import script from "./MeasurementsForm.vue?vue&type=script&lang=js"
export * from "./MeasurementsForm.vue?vue&type=script&lang=js"

import "./MeasurementsForm.vue?vue&type=style&index=0&id=79e348e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e348e1"]])

export default __exports__